import { Button } from "@mui/material";
import { Link } from "react-router-dom";

import { rewardInventoryPortalPaths, rootPaths } from "../../routes/routePaths";
import Text from "../atoms/Text";
import PlusIcon from "../icons/ui/PlusIcon";

type Props = {
  width?: number;
};

const CreateButton = ({ width = 197 }: Props) => {
  return (
    <Button
      component={Link}
      to={`${rootPaths.rewardInventoryPortal}/${rewardInventoryPortalPaths.createProduct}`}
      size="small"
      variant="primary"
      sx={{
        width,
      }}
      endIcon={<PlusIcon />}
      data-testid="inventory-homepage_create-product_button"
    >
      <Text variant="title_xsmall">Create Product</Text>
    </Button>
  );
};

export default CreateButton;
